const updates = [
  { id: 1, time: '07-20 18:30', content: '吃瓜爆料网App安卓端v3.2.1版本更新发布，优化推送速度和内容加载体验' },
  { id: 2, time: '07-20 15:12', content: '新增“反差视频”专区，集中展示博主反差内容，访问量单日突破50万' },
  { id: 3, time: '07-20 11:45', content: '吃瓜爆料网站服务器完成扩容，应对近期访问高峰，加载速度提升40%' },
  { id: 4, time: '07-19 22:08', content: '某顶流塌房专题发布后引发全网热议，相关话题登上多平台热搜榜首' },
  { id: 5, time: '07-19 16:30', content: '吃瓜爆料网iOS端App通过App Store审核，全新界面设计获得用户好评' },
  { id: 6, time: '07-19 10:15', content: '投稿通道新增匿名加密功能，保护爆料人隐私安全，已收到多条独家线索' },
  { id: 7, time: '07-18 20:00', content: '网站新增“吃瓜热榜”功能，实时展示当前热度最高的吃瓜话题排名' },
  { id: 8, time: '07-18 14:22', content: '吃瓜爆料网最新地址同步更新完毕，所有备用域名均已生效，确保入口稳定' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">最新动态</h2>
          <p className="text-sm text-foreground-500">平台实时更新，不错过每一个变化</p>
        </div>

        <div className="relative pl-8 before:absolute before:left-[11px] before:top-0 before:bottom-0 before:w-px before:bg-background-300">
          {updates.map((item, idx) => {
            const isNew = idx < 2;
            return (
              <div key={item.id} className={`relative pb-6 ${idx === updates.length - 1 ? 'pb-0' : ''}`}>
                <div className={`absolute -left-[27px] top-1 w-3.5 h-3.5 rounded-full border-2 ${
                  isNew ? 'bg-accent-500 border-accent-500' : 'bg-background-50 border-background-300'
                }`} />
                <div className="flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-4">
                  <span className={`text-xs whitespace-nowrap font-medium ${isNew ? 'text-accent-600' : 'text-foreground-400'}`}>
                    {item.time}
                  </span>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    {item.content}
                    {isNew && (
                      <span className="ml-2 px-2 py-0.5 rounded-full bg-accent-100 text-accent-600 text-xs font-medium whitespace-nowrap">
                        最新
                      </span>
                    )}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}